import ActionTypes from 'constants/ActionTypes';

/**
 * Redux action creators for persistent UI changes
 */

export const setParams = payload => ({
    type: ActionTypes.PARAMS_SET,
    error: false,
    payload: {
        query: payload.query,
        domain: payload.domain,
        languageId: payload.languageId,
        locationId: payload.locationId,
        page: payload.page,
        orderBy: payload.orderBy,
        orderDirection: payload.orderDirection,
        competitors: payload.competitors,
        mode: payload.mode,
        pages: payload.pages,
        excludePages: payload.excludePages,
    },
});

export const setPage = payload => ({
    type: ActionTypes.PARAMS_SET_PAGE,
    error: false,
    payload: {
        page: payload.page,
    },
});
